import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withStyles } from 'theme/withStyles';
import RawHtml from 'common/RawHtml';
import dialogActions from 'core/dialogs/actions';
import BottomContent from 'common/BottomContent';
import checkboxStyles from 'styles/checkbox';

import visuallyHidden from 'styles/visuallyHidden';
import buttonLinkStyles from 'styles/buttonLink';
import pageActions from 'core/page/actions';
import commonStyles from './styles';

const styles = (theme) => {
  const common = commonStyles(theme);

  return {
    ...common,
    agreement: {
      '& .statusDiv': {
        '& .trigger-esign-modal': {
          margin: '10px 0 0 10px',
        },
        '& .trigger-msign-modal': {
          display: 'inline',
          fontSize: 24,
          margin: '10px 0 0 10px',
        },
        '&.signButtons': {
          border: 'none',
        },
        borderRight: `1px solid ${theme.palette.form.border}`,
        marginRight: theme.spacing.xs,
        paddingLeft: theme.spacing.sm + theme.spacing.unit,
        paddingRight: theme.spacing.xs,
        position: 'relative',
      },
      '&:last-child': {
        borderBottom: 'none',
        marginBottom: 0,
        paddingBottom: 0,
      },
      borderBottom: `1px solid ${theme.palette.form.border}`,
      display: 'flex',
      flexWrap: 'wrap',
      marginBottom: theme.spacing.sm,
      paddingBottom: theme.spacing.sm,
    },
    buttonLink: {
      ...buttonLinkStyles(theme),
    },
    desc: {
      marginBottom: theme.spacing.sm,
      width: '100%',
    },
    handle: {
      '&:hover': {
        textDecoration: 'underline',
      },
      fontWeight: theme.typography.fontWeights.bold,
      textDecoration: 'none',
    },
    input: {
      ...checkboxStyles(theme),
      left: 0,
      position: 'absolute',
      top: 0,
    },
    label: {
      fontWeight: 700,
      marginBottom: theme.spacing.xs,
      width: '100%',
    },
    visuallyHidden,
  };
};

const EsignAgreementsBare = ({
  agreementSignedLabel,
  agreements,
  bottomContent,
  classes,
  disclosureViewDocumentLabel,
  loading,
  openDialog,
  saveSignature,
}) => {
  const [isSignedManually, setIsSignedManually] = useState([]);
  const signManually = (id) => () => {
    saveSignature(id, { manuallySigned: true });
    setIsSignedManually([...isSignedManually, id]);
  };
  return (
    <>
      <div className={classnames('agreements form-group', classes.agreements)}>
        {agreements.map((a) => (
          <div key={a.id} className={classnames(`agreement-${a.id}`, classes.agreement)}>
            <RawHtml type="label" className={classes.label}>
              {a.label}
            </RawHtml>
            <RawHtml className={classnames('desc', classes.desc, { greyed: a.readOnly })}>
              {a.description}
            </RawHtml>
            {(a.requireESign || a.requireManualSign) && !a.readOnly ? (
              <div className="statusDiv signButtons">
                <RawHtml
                  type="button"
                  className={classnames('trigger-esign-modal btn btn-mobile', classes.handle)}
                  onClick={(e) => {
                    e.preventDefault();
                    openDialog('esign', a);
                  }}
                >
                  {a.viewSignLabel}
                </RawHtml>
                {a.requireManualSign && (
                  <RawHtml
                    type="button"
                    variant="tertiary"
                    className={classnames('trigger-msign-modal btn btn-mobile', classes.handle)}
                    onClick={signManually(a.id)}
                    disabled={loading}
                  >
                    {a.viewManualSignLabel}
                  </RawHtml>
                )}
              </div>
            ) : (
              <>
                {!a.readOnly && (
                  <div className={classnames('checkbox form-group statusDiv')}>
                    <fieldset>
                      <input
                        id={`agreement-${a.id}`}
                        type="checkbox"
                        disabled
                        checked
                        className={classes.input}
                      />{' '}
                      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                      <label>{`${agreementSignedLabel} ${
                        isSignedManually.includes(a.id) ? 'Manually' : ''
                      }`}</label>
                    </fieldset>
                  </div>
                )}
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <button
                  type="button"
                  className={classnames('buttonLink trigger-view-modal', classes.buttonLink)}
                  onClick={(e) => {
                    e.preventDefault();

                    openDialog('esignViewOnly', a);
                  }}
                >
                  {disclosureViewDocumentLabel}
                  <span className={classnames('hidden', classes.visuallyHidden)}> - {a.label}</span>
                </button>
              </>
            )}
          </div>
        ))}
      </div>

      <BottomContent className="bottomContent">{bottomContent}</BottomContent>
    </>
  );
};

EsignAgreementsBare.propTypes = {
  agreementSignedLabel: PropTypes.string,
  agreements: PropTypes.arrayOf(PropTypes.shape({})),
  bottomContent: PropTypes.string,
  disclosureViewDocumentLabel: PropTypes.string,
  loading: PropTypes.bool,
  openDialog: PropTypes.func.isRequired,
  saveSignature: PropTypes.func.isRequired,
};

EsignAgreementsBare.defaultProps = {
  agreementSignedLabel: 'Signed',
  agreements: [],
  bottomContent: '',
  disclosureViewDocumentLabel: 'View Document',
  loading: false,
};

const mapStateToProps = ({ data, dialogs, groups, resources }, { name }) => ({
  agreementSignedLabel: resources.agreementSignedLabel,
  agreements: data.agreements,
  bottomContent: groups[name].bottomContent,
  disclosureViewDocumentLabel: resources.disclosureViewDocumentLabel,
  loading: dialogs?.params?.loading,
});

const EsignAgreementsStyled = withStyles(styles)(EsignAgreementsBare);

export default connect(mapStateToProps, {
  openDialog: dialogActions.open,
  saveSignature: pageActions.saveSignature,
})(EsignAgreementsStyled);
